const ApodMedia = ({ url, embedUrl, mediaType, title, classPrefix = 'lounge-apod' }) => {
  if (embedUrl) {
    return (
      <div className={`${classPrefix}-embed-wrap`}>
        <iframe
          className={`${classPrefix}-embed`}
          src={embedUrl}
          title={title || 'NASA video of the day'}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }

  if (mediaType === 'video' && url) {
    return (
      <video
        className={`${classPrefix}-video`}
        src={url}
        controls
        playsInline
        preload="metadata"
      />
    );
  }

  if (url) {
    return (
      <img
        className={`${classPrefix}-image`}
        src={url}
        alt={title || 'NASA Astronomy Picture of the Day'}
      />
    );
  }

  return null;
};

export default ApodMedia;